<section class="second-opinion-fr" aria-labelledby="second-opinion-fr-title">
  <h2 id="second-opinion-fr-title">Deuxième avis médical</h2>

  <h3>Une demande gratuite, simple et rapide, depuis chez vous</h3>
  <p>
    Vous pouvez soumettre votre demande de deuxième avis
    <a [href]="secondOpinionUrl" target="_blank" rel="noopener noreferrer">en cliquant ici</a>.
    Une fois votre demande validée, vous recevrez une réponse dans un délai moyen d'environ sept jours.
  </p>
  <p>
    La demande peut être réalisée par vous-même, un de vos proches ou votre médecin. L’avis est entièrement pris en
    charge sans avance de frais pour tous les patients disposant d’un numéro de sécurité sociale français. Si vous
    n’êtes pas assuré social, vous pouvez faire une
    <a [href]="internationalSecondOpinionUrl" target="_blank" rel="noopener noreferrer">demande de second avis international ici</a>.
  </p>
  <p>
    Selon la complexité de votre cas, si le médecin qui prend en charge votre dossier l’estime nécessaire, votre
    dossier peut être discuté en réunion de concertation pluridisciplinaire (RCP) ; le délai de réponse sera alors
    supérieur à sept jours.
  </p>
  <p>
    Le service de deuxième avis Gustave Roussy est assuré en partenariat avec le service Deuxième Avis, externe à
    Gustave Roussy. Tous les avis sont rendus par des experts de Gustave Roussy, mais le service patient avec qui vous
    pouvez échanger par téléphone ou par mail est assuré par Deuxième Avis.
  </p>

  <p class="second-opinion-fr__cta">
    <a class="second-opinion-fr__button" [href]="secondOpinionUrl" target="_blank" rel="noopener noreferrer">
      DEMANDER UN DEUXIÈME AVIS
    </a>
  </p>

  <p>
    Si le traitement adapté n'est pas réalisable par l'équipe qui vous prend en charge actuellement (essai clinique,
    nouvelle molécule, curiethérapie…), une consultation à Gustave Roussy vous sera proposée.
  </p>

  <div class="second-opinion-fr__notice">
    <ul>
      <li>Si vous êtes déjà patient de Gustave Roussy : rapprochez-vous de vos contacts habituels.</li>
      <li>
        If you are an international patient: please use the "international patient" button above to access our international patients second opinion platform.
      </li>
      <li>
        Dans le cas d’une demande de deuxième avis concernant une <strong>tumeur testiculaire</strong>, merci d’adresser votre demande
        à <a href="mailto:urologie@gustaveroussy.fr">urologie&#64;gustaveroussy.fr</a>.
      </li>
    </ul>
  </div>

  <h3>Contacter le service patients Deuxième Avis</h3>
  <p>
    Une fois votre demande d’avis effectuée, pour toute question, contactez directement le
    <strong>service patients Deuxième Avis</strong> au <a href="tel:+33181800048">01 81 80 00 48</a> ou à l'adresse
    <a href="mailto:contact@deuxiemeavis.fr">contact&#64;deuxiemeavis.fr</a>, qui sera en capacité de vous renseigner
    sur l’avancée de votre demande. <strong>Les médecins et les secrétariats de Gustave Roussy ne pourront vous
    communiquer aucune information, et aucune réponse ne sera donnée en dehors de la plateforme.</strong>
  </p>
  <p>
    Si vous souhaitez <strong>envoyer certains de vos documents par courrier</strong>, merci de compléter votre demande en
    sélectionnant cette modalité dans la plateforme au moment d'ajouter les pièces jointes. L'adresse de destination
    vous sera communiquée dans la plateforme. Aucun document envoyé directement à Gustave Roussy ne sera pris en
    compte dans votre demande.
  </p>

  <h3>Un accès facilité à l’expertise de Gustave Roussy</h3>
  <p>
    Premier Centre de Lutte Contre le Cancer en Europe, Gustave Roussy est classé par le Magazine Newsweek comme le
    4ème meilleur hôpital spécialisé en oncologie, et premier en dehors des États-Unis. L’établissement traite des
    patients de tous âges atteints de tous types de cancer, et est expert dans le traitement des tumeurs rares et
    complexes. Nous plaçons l’innovation au cœur d’une révolution humaine, scientifique et technologique dans la lutte
    contre le cancer.
  </p>
  <p>
    Parmi ses médecins, Gustave Roussy compte des experts de renommée internationale, dont notamment 15
    médecins-chercheurs figurant dans la liste des Highly Cited Researchers en 2023. Cette liste identifie les
    chercheurs qui exercent une influence mondiale significative dans leur domaine de recherche : un résultat reflet
    de l’excellence du travail de recherche et d’innovation menés au sein de l’institut.
  </p>
  <p>
    Demander un second avis à Gustave Roussy, c’est s’assurer que l’avis qui vous sera donné prend en compte les
    dernières connaissances scientifiques sur le diagnostic et le traitement du cancer, y compris pour les cancers
    rares, les techniques de pointe et les traitements innovants.
  </p>
  <p>Un second avis peut vous être proposé pour les spécialités oncologiques suivantes :</p>
  <ul class="second-opinion-fr__specialties">
    <li>Cervico-facial</li>
    <li>Dermatologie</li>
    <li>Digestif</li>
    <li>Gynécologie</li>
    <li>Hématologie</li>
    <li>Neurologie</li>
    <li>Cancérologie de l'enfant et de l'adolescent</li>
    <li>Thorax</li>
    <li>Génito-urinaire (sauf tumeurs testiculaires)</li>
    <li>Sarcome</li>
    <li>Sénologie</li>
    <li>Radiologie et radiologie interventionnelle</li>
    <li>Douleurs cancéreuses</li>
  </ul>

  <p class="second-opinion-fr__cta">
    <a class="second-opinion-fr__button" [href]="secondOpinionUrl" target="_blank" rel="noopener noreferrer">
      DEMANDER UN DEUXIÈME AVIS
    </a>
  </p>
  <p>
    If you are an international patient, our please use the "international patient" button above to access our international patients second opinion platform.
  </p>
</section>
